<template>
    <div id="unlogin" v-wechat-title="title" v-show="isLogin" :style="{ height: `${this.screenHeight}px`, overflow: `auto` }">
        <el-row v-show="unLoginScheduleHeadingStyleobj">
            <el-col :span="5" class="surgeryType">
                <i :style="{ background: headingStyle.jzbackground }"></i>&nbsp;<span :style="{ 'font-size': headingStyle.jzfontsize }">急诊({{ jzCount }})</span>&nbsp;&nbsp;
                <i :style="{ background: headingStyle.zqbackground }"></i>&nbsp;<span :style="{ 'font-size': headingStyle.zqfontsize }">择期({{ zqCount }})</span>
            </el-col>
            <el-col :span="15" class="align-center line-height100 surgeryStatus1" v-html="headText"> </el-col>
            <el-col :span="4">
                <span :style="{ 'font-size': headingStyle.nCostTimefontsize, color: headingStyle.nCostTimecolor, 'font-weight': `bold` }" title="剩余时长">{{ nCostTime }}</span>
                <span :style="{ 'font-size': headingStyle.allCostTimefontsize, color: headingStyle.allCostTimecolor, 'font-weight': `bold` }" title="预计总时长">/{{ allCostTime }}小时</span>
            </el-col>
        </el-row>
        <crud-facecade
            ref="surgery-list"
            :url="url"
            :stripe="!unLoginScheduleHeadingStyleobj"
            :disableOrderDefaultSort="true"
            :columns="userListColumn"
            :buttons="buttons"
            :selection="true"
            @selectionChange="checkedRow"
            dialogWidth="80%"
            :tableHeight="screenHeight - 100 + formHeight - queryPanelHeight"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            @accurateQuery="accurateQuery"
            :columnConfig="false"
        >
            <slot slot="filter">
                <el-col :span="6">
                    <item-input type="daterange" v-model="rdate" :noPadding="true" @input="reload"></item-input>
                </el-col>
                <el-col :span="3">
                    <item-input type="select" v-model="dic_operating_ward_id" @input="reload" :options="operation_ward_auth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :span="3">
                    <item-input type="multiselect" v-model="dic_section_id" :readonly="!alowEditSection" @input="reload" :options="section_auth" :collapseTags="false" :clearable="true" placeholder="请选择科室"></item-input>
                </el-col>
                <el-col :span="3" v-if="isSearchEmergency">
                    <item-input type="select" v-model="surgery_type" @input="reload" :options="surgeryTypes" :clearable="true" placeholder="手术类型"></item-input>
                </el-col>
                <el-col :span="3">
                    <item-input type="multiselect" v-model="surgery_status" @input="reload" :options="allSurgeryStatus" :clearable="true" placeholder="手术状态"></item-input>
                </el-col>
                <el-col :span="3">
                    <item-input type="string" v-model="surgeon" :clearable="true" placeholder="手术医生"></item-input>
                </el-col>
                <el-col :span="3">
                    <item-input type="string" v-model="anes_doctor" :clearable="true" placeholder="麻醉医生"></item-input>
                </el-col>
            </slot>
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="reload()" title="刷新当前页面">刷新<i class="el-icon--right"></i></el-button>
                <!-- 仅供急诊科创建急诊手术使用 -->
                <el-button type="primary" size="mini" v-if="isCreateEmergency" @click="AddEmergencySurgery">创建急诊手术<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" v-if="isShowPrint && (!printSurgeryConfigs || printSurgeryConfigs.length == 0)" @click="print">打印<i class="el-icon--right"></i></el-button>

                <el-dropdown @command="printSurenry" v-if="isShowPrint && printSurgeryConfigs && printSurgeryConfigs.length > 0">
                    <el-button type="primary" size="mini">打印<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="item in printSurgeryConfigs" :key="item.code" v-text="item.value" :command="item"></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button type="primary" size="mini" v-if="isShowExport" @click="ExportExcel">导出<i class="el-icon--right"></i></el-button>
                <el-popover placement="bottom" :open-delay="600">
                    <el-button size="mini" plain slot="reference">
                        <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                        <span class="hidden-md-and-down">&nbsp;列配置</span>
                    </el-button>
                    <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 250px; width: max-content">
                        <div class="config-column">
                            <item-input type="checkboxgroup" :options="configColumns" v-model="user_config_columns"></item-input>
                        </div>
                    </el-scrollbar>

                    <el-divider></el-divider>
                    <div style="text-align: right">
                        <el-link type="primary" size="mini" class="margin-right10" @click="SaveUserColumns">保存</el-link>
                    </div>
                </el-popover>
            </template>
            <template slot="surgery_status1" slot-scope="{ row }">
                <div :style="getstyle(row)">
                    {{ row.surgery_status1 }}
                </div>
            </template>
            <template slot="surgery_type" slot-scope="{ row }">
                <i
                    :style="{ background: row.enum_surgery_type == 1 ? `red` : `#088D85`, width: `16px`, height: `16px`, display: `inline-block`, 'border-radius': `50%`, 'vertical-align': `middle` }"
                    :title="row.surgery_type"
                ></i>{{row.is_emergency == 1 ? `急诊科` : ``}}
            </template>
        </crud-facecade>
        <form-dialog
            :title="exportExcel.title"
            :data="exportExcel.data"
            width="40%"
            :visible.sync="exportExcel.dialogFormVisible"
            :columns="exportExcel.Columns"
            @confirm="exportExcelSave"
        ></form-dialog>
        <AddSurgery :visible.sync="addfrom.dialogFormVisible" :isEmergency="addfrom.isEmergency" :defaultplanTime="addfrom.defaultplanTime" @afteradd="afteradd"> </AddSurgery>
    </div>
</template>
<script>
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
import AddSurgery from './AddSurgery.vue'
export default {
    name: `UnLoginApplySurgery`,
    components: { AddSurgery },
    props: {},

    data() {
        return {
            isLogin: false,
            headText: ``,
            user: this.$route.query.user,
            newuser: this.$route.query.newuser,
            key: this.$route.query.key,
            newkey: this.$route.query.newkey,
            surgerycardno: this.$route.query.surgerycardno,
            surgeryname: null,
            ACISForm: this.$route.query.ACISForm,
            sectionCode: this.$route.query.sectionCode,
            inpatientSectionCode: this.$route.query.inpatientSectionCode,
            surgery_type: this.$route.query.surgery_type,
            alowEditSection: true,
            alowEditInpatientSection: true,
            setUnLoginScheduleRefreshInterval: this.$root.UnLoginScheduleRefreshInterval, // 第三方手术排程信息调阅界面自动刷新时间间隔
            setUnLoginSurgeryStatus: this.$root.setUnLoginSurgeryStatus, // 第三方手术排程信息调阅界面手术状态配置
            unLoginScheduleHeadingStyle: this.$root.UnLoginScheduleHeadingStyle, // 排程信息界面设置状态汇总样式
            unLoginScheduleUpdateSection: this.$root.UnLoginScheduleUpdateSection, // 第三方排程页面是否允许调整科室
            headingStyle: {
                jzbackground: `red`,
                jzfontsize: `18px`,
                zqbackground: `#088D85`,
                zqfontsize: `18px`,
                nCostTimecolor: `red`,
                nCostTimefontsize: `30px`,
                allCostTimecolor: `black`,
                allCostTimefontsize: `25px`
            },
            unLoginScheduleHeadingStyleobj: null,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            isAllStatus: this.$route.query.isAllStatus || 0,
            formSurgeryStatus: this.$route.query.surgeryStatus,
            isEnableFilterStatusForExportExcel: this.$root.IsEnableFilterStatusForExportExcel, // 是否开启导出Excel 按状态过滤数据
            title: `排程信息`,
            url: {
                baseURL: `/api/Preoperative/Apply`,
                get: paras => {
                    return this.reloadListData()
                }
            },
            buttons: [],
            rdate: this.loadDefaultValue(),
            dic_operating_ward_id: this.$route.query.active_ward || undefined,
            dic_section_id: undefined,
            dic_inpatient_id: undefined,
            surgery_status: [],
            statusStyleConfig: [],
            configColumns: [],
            user_config_columns: [],
            isShowPrint: false,
            isShowExport: false,
            inpatient_section: [],
            queryPanelHeight: 0,
            formHeight: 0,
            allSurgeryStatus: [],
            // -1:手术驳回，-2:手术终止，10:新申请，20:已排程，30:手术中，40:手术结束，50:苏醒中，60:苏醒结束
            searchSurgeryStatus: [
                { label: `手术驳回`, value: `-1` },
                { label: `手术终止`, value: `-2` },
                { label: `新申请`, value: `10` },
                { label: `已排程`, value: `20` },
                { label: `手术中`, value: `30` },
                { label: `手术结束`, value: `40` },
                { label: `苏醒中`, value: `50` },
                { label: `苏醒结束`, value: `60` }
            ],
            exportExcel: {
                title: `导出数据过滤`, // ACIS-23414, 手术排程，跨区域排程手术，排程助手下，增加'更换手术间'按钮
                data: {},
                exportDatas: [],
                dialogFormVisible: false,
                Columns: [{
                    type: `checkboxgroup`,
                    prop: `status`,
                    label: `状态:`,
                    options: [{ label: `已排程`, value: `已排程` }, { label: `进行中`, value: `进行中` }, { label: `手术结束`, value: `手术结束` }, { label: `苏醒中`, value: `苏醒中` }, { label: `苏醒结束`, value: `苏醒结束` }],
                    colspan: 24,
                    default: [
                        `已排程`,
                        `进行中`,
                        `手术结束`,
                        `苏醒中`,
                        `苏醒结束`
                    ]
                }]
            },
            surgeryList: [],
            jzCount: 0,
            zqCount: 0,
            nCostTime: 0,
            allCostTime: 0,
            surgeon: ``,
            anes_doctor: ``,
            checkedRows: [],
            printSurgeryConfigs: [],
            addfrom: {
                dialogFormVisible: false,
                defaultplanTime: this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            },
            surgeryTypes: [
                { label: `择期`, value: 2 },
                { label: `急诊`, value: 1 },
                { label: `急诊[急诊科]`, value: -1 }],
            isCreateEmergency: false,
            isSearchEmergency: false
        }
    },
    beforeDestroy() {
        clearInterval(this.refreshListData)
    },
    created() {
        let that = this
        // 加载用户token
        this.loadToken().then(() => {
            that.loadPrintSurgeryConfig()
            this.$store.dispatch(`ADD_OtherSettingColumn`)
            this.$store.dispatch(`ADD_ExtendColumnList`)
            clearInterval(this.refreshListData)
            if (that.ACISForm && that.ACISForm == 1) {
                that.formHeight = 50
            }
            if (that.unLoginScheduleHeadingStyle) {
                that.unLoginScheduleHeadingStyleobj = eval(
                    `(` + this.unLoginScheduleHeadingStyle + `)`
                )
                if (that.unLoginScheduleHeadingStyleobj && that.unLoginScheduleHeadingStyleobj.surgeryType) {
                    let jz = _.filter(that.unLoginScheduleHeadingStyleobj.surgeryType, { lable: `急诊` })
                    if (jz && jz[0]) {
                        that.headingStyle.jzbackground = jz[0].color || `red`
                        that.headingStyle.jzfontsize = jz[0].font_size || `18px`
                    }
                    let zq = _.filter(that.unLoginScheduleHeadingStyleobj.surgeryType, { lable: `择期` })
                    if (zq && zq[0]) {
                        that.headingStyle.zqbackground = zq[0].color || `#088D85`
                        that.headingStyle.zqfontsize = zq[0].font_size || `18px`
                    }
                }
                if (that.unLoginScheduleHeadingStyleobj && that.unLoginScheduleHeadingStyleobj.surgeryStatus) {
                    that.unLoginScheduleHeadingStyleobj.surgeryStatus = _.map(that.unLoginScheduleHeadingStyleobj.surgeryStatus, t => {
                        t.surgeryStatus_array = t.surgeryStatus.split(`,`)
                        return t
                    })
                }
                if (that.unLoginScheduleHeadingStyleobj && that.unLoginScheduleHeadingStyleobj.costTime) {
                    let ncostTime = _.filter(that.unLoginScheduleHeadingStyleobj.costTime, { lable: `剩余时长` })
                    if (ncostTime && ncostTime[0]) {
                        that.headingStyle.nCostTimecolor = ncostTime[0].color || `red`
                        that.headingStyle.nCostTimefontsize = ncostTime[0].font_size || `30px`
                    }
                    let allcostTime = _.filter(that.unLoginScheduleHeadingStyleobj.costTime, { lable: `预计总时长` })
                    if (allcostTime && allcostTime[0]) {
                        that.headingStyle.allCostTimecolor = allcostTime[0].color || `black`
                        that.headingStyle.allCostTimefontsize = allcostTime[0].font_size || `25px`
                    }
                }
                if (that.unLoginScheduleHeadingStyleobj) {
                    that.queryPanelHeight = 38
                }
            }
            that.getStatusStyleConfig()
            that.$store.dispatch(`sysuser/ADD_WORKERS`).then(() => {
                that.$store.dispatch(`ADD_SECTION_AUTH`).then(() => {
                    that.$store.dispatch(`ADD_Inpatient_Section_AUTH`).then(() => {
                        that.loadingInpatientSectionData().then(() => {
                            // 捞取入参的科室编码sectionCode
                            if (that.sectionCode) {
                                var sed = that.sectionCode.split(`,`)

                                var sectionInfo = that.section_auth && _.filter(that.section_auth, d => {
                                    return d.code && _.includes(sed, d.code)
                                })
                                if (sectionInfo && sectionInfo.length > 0) {
                                    that.dic_section_id = sectionInfo.map(c => c.value)
                                }
                                if (that.unLoginScheduleUpdateSection == `0`) {
                                    that.alowEditSection = false
                                }
                            }
                            // 捞取入参的病区编码sectionCode
                            if (that.inpatientSectionCode) {
                                console.log(`InpatientSection`, that.inpatient_section)
                                var inpatientSectionInfo = that.inpatient_section && _.filter(that.inpatient_section, d => {
                                    return d.code && d.code == that.inpatientSectionCode
                                })
                                if (inpatientSectionInfo && inpatientSectionInfo.length > 0) {
                                    that.dic_inpatient_id = inpatientSectionInfo[0].value
                                }
                                that.alowEditInpatientSection = false
                            }
                            that.$store.dispatch(`ADD_OPERATION_WARD_AUTH`).then(() => {
                                that.$store.dispatch(`enums/ADD_ALL_ENUM`).then(() => {
                                    that.reload()
                                    that.getSurgeryStatus()
                                })
                            })
                        })
                    })
                })
            })

            that.loadButtonsShowHidden()
            // 加载配置列
            that.loadConfigColumns()
            that.configColumnDrop()
            that.loadDefaultValue()
            if (that.setUnLoginScheduleRefreshInterval && that.setUnLoginScheduleRefreshInterval > 0) {
                that.refreshListData = setInterval(() => {
                    that.reload()
                }, that.setUnLoginScheduleRefreshInterval * 1000)
            }
        })
    },
    computed: {
        ...mapGetters([`sys_enums`, `localip/ipAddress`, `section_auth`, `active_ward`, `screenHeight`, `sysuser/workers_by_duty`, `sysuser/workers_by_dutyNew`, `operation_ward_auth`,
            `otherSettingColumn`,
            `extendColumnList`]),
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        columnList() {
            let me = this
            let list = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    width: `60`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `scheduled_sequence`,
                    label: `台次`,
                    width: `60`,
                    isListable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `sequence`,
                    label: `申请台次`,
                    width: `100`,
                    isListable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `select`,
                    prop: `sex`,
                    label: `性别`,
                    width: `60`,
                    isListable: true,
                    searchable: true,
                    sortable: false,
                    options: (that, { row }) => {
                        return (
                            (me.sys_enums &&
                                me.sys_enums.Enum_Sex &&
                                me.sys_enums.Enum_Sex.map(d => {
                                    d.value = d.label
                                    return d
                                })) ||
                            []
                        )
                    }
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    width: `60`,
                    isListable: true,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `custom`,
                    prop: `surgery_status1`,
                    label: `状态`,
                    width: `80`,
                    isListable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `his_id`,
                    label: this.T(`his_id`),
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`apply_surgery.visit_no`),
                    isListable: true,
                    searchable: false,
                    sortable: false,
                    width: `120`
                },
                {
                    type: `select`,
                    prop: `surgery_type`,
                    label: `类型`,
                    width: `80`,
                    isListable: false,
                    searchable: true,
                    options: (that, { row }) => {
                        let SurgeryTypes = _.cloneDeep(me.sys_enums && me.sys_enums.Enum_SurgeryType)
                        return (
                            SurgeryTypes &&
                                SurgeryTypes.map(d => {
                                    d.value = d.label
                                    return d
                                })) ||
                            []
                    }
                },
                {
                    type: `custom`,
                    prop: `surgery_type`,
                    label: `类型`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `is_local_anes_val`,
                    label: `麻醉类型`,
                    width: `120`,
                    isListable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `120`,
                    isListable: true,
                    sortable: true
                },
                {
                    type: `select`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    width: `120`,
                    isListable: false,
                    searchable: true,
                    readonly: !this.alowEditInpatientSection,
                    options: this.inpatient_section
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    width: `120`,
                    isListable: true,
                    sortable: true
                },
                {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    width: `120`,
                    isListable: false,
                    searchable: true,
                    sortable: false,
                    options: (that, { row }) => {
                        let rooms = []
                        let operation = me.operation_ward_auth
                        if (operation) {
                            _.forEach(operation, op => {
                                if (_.has(op, `value`) && _.has(op, `operation_room`)) {
                                    _.forEach(op.operation_room, r => {
                                        if (_.has(r, `label`)) {
                                            let room = {
                                                value: r.value,
                                                label: r.label,
                                                opid: op.value,
                                                code: op.label
                                            }
                                            rooms.push(room)
                                        }
                                    })
                                }
                            })
                        }
                        if (me.dic_operating_ward_id) {
                            rooms = _.filter(rooms, function(r) {
                                return r.opid == me.dic_operating_ward_id
                            })
                        }
                        return rooms
                    }
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `120`,
                    isListable: true,
                    searchable: false,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    width: `60`,
                    isListable: true,
                    searchable: true,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `诊断`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `手术方式`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `anaes_methods`,
                    label: `麻醉方式`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `计划开始时间`,
                    width: `120`,
                    isListable: true,
                    searchable: true,
                    sortable: true
                },
                {
                    type: `datetime`,
                    prop: `apply_time`,
                    label: `申请时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `in_room_time`,
                    label: `入手术间时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `operation_begin`,
                    label: `手术开始时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `operation_end`,
                    label: `手术结束时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `out_room_time`,
                    label: `出手术间时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `in_recovery_room`,
                    label: `入复苏室时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `out_recovery_room`,
                    label: `出复苏室时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: `手术医生`,
                    width: `80`,
                    isListable: true,
                    isExpand: false
                },
                {
                    type: `string`,
                    prop: `abbr`,
                    label: `简拼`
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: `手术助手`,
                    width: `120`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `anes_doctor`,
                    label: `麻醉医生`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anes_assistants`,
                    label: `麻醉助手`,
                    width: `140`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `circuit_nurse`,
                    label: `巡回护士`,
                    width: `140`,
                    isListable: true,
                    searchable: true
                },

                {
                    type: `string`,
                    prop: `equipment_nurse`,
                    label: `器械护士`,
                    width: `140`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `float`,
                    prop: `cost_time`,
                    label: `预计时长`,
                    width: `140`,
                    isListable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `surgical_site`,
                    label: `手术部位`,
                    width: `150`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `his_remark`,
                    label: `申请备注`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    width: `140`,
                    isListable: true
                }
            ] // 列表列
            // 显示动态扩展列
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, list)

            return list
        },
        userListColumn() {
            let that = this
            if (this.configColumns.length == 0) {
                return this.columnList
            } else if (this.user_config_columns.length == 0) {
                // added by xiaorui,默认如果用户没有配置任何列 则 1.列配置勾选上当前页面所有列 2.展示当前列表上所有列
                that.user_config_columns = that.configColumns.map(c => c.value)
                return this.columnList
            }

            let allcolumn = _.filter(this.columnList, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            return r
        }
    },
    methods: {
        AddEmergencySurgery() {
            let that = this
            that.addfrom.dialogFormVisible = true
            that.addfrom.isEmergency = 1
            that.addfrom.defaultplanTime = that.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            return false
        },
        afteradd(aftersaveid) {
            let that = this
            that.$message.success(`保存成功`)
            that.reload()
        },
        loadPrintSurgeryConfig() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=UnLoginPrintSurgeryConfig`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.printSurgeryConfigs = JSON.parse(data.value)
                    } else {
                        this.printSurgeryConfigs = []
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        checkedRow({ row }) {
            this.checkedRows = row
        },
        printSurenry(command) {
            let that = this
            if (command && command.code) {
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                req2.then(isShow => {
                    var objidal = ``
                    if (that.checkedRows.length > 0) {
                        objidal = that.checkedRows.map(d => d.id).toString()
                    } else {
                        var searchStatus = (that.surgery_status && that.searchSurgeryStatus && _.filter(that.searchSurgeryStatus, d => {
                            return _.includes(that.surgery_status, d.label)
                        }) || []).map(d => d.value).toString()
                        let wardId = that.dic_operating_ward_id || 0
                        let sectionId = this.dic_section_id && this.dic_section_id.join(`,`) || 0
                        let status = searchStatus
                        let keyValue = that.$refs[`surgery-list`] && that.$refs[`surgery-list`].searchValue
                        objidal = `${wardId}|${sectionId}|${status}|${keyValue}`
                    }
                    console.log(`objidal`, objidal)
                    that.$store.dispatch(`PRINT_PDF`, {
                        host: that.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: that.$root.DOCUMENT[command.code],
                                id1: `99999`,
                                objId: objidal,
                                from: that.$moment(that.rdate[0]).format(`YYYYMMDDHHmm`),
                                to: that.$moment(that.rdate[1]).add(1, `days`).format(`YYYYMMDDHHmm`)
                            },
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        print() {
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                // 批量打印手术通知单
                let wardId = this.dic_operating_ward_id || 0
                let sectionId = this.dic_section_id && this.dic_section_id.join(`,`) || 0
                let date = this.$moment(this.rdate[0]).format(`YYYY/MM/DD 00:00:00`)
                let keyValue = this.$refs[`surgery-list`] && this.$refs[`surgery-list`].searchValue
                console.log(`${wardId}|${date}|${sectionId}|${keyValue}`)
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: this.$root.DOCUMENT[`PC010`],
                            id1: ``,
                            objId: `${wardId}|${date}|${sectionId}|${keyValue}`,
                            from: this.$moment(this.rdate[0]).format(`YYYYMMDDHHmm`),
                            to: this.$moment(this.rdate[1]).add(1, `days`).format(`YYYYMMDDHHmm`)
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        },
        getSurgeryStatus() {
            let that = this
            let allStatus = that.sys_enums && that.sys_enums.SurgeryStatus || []
            let newStatus = []
            if (that.unLoginScheduleHeadingStyleobj && that.unLoginScheduleHeadingStyleobj.surgeryStatus) {
                allStatus = _.map(allStatus, t => {
                    _.forEach(that.unLoginScheduleHeadingStyleobj.surgeryStatus, d => {
                        if (_.includes(d.surgeryStatus_array, t.value.toString())) {
                            t.label = d.label
                            return false
                        }
                    })
                    return t
                })
            }
            if (that.setUnLoginSurgeryStatus && (!that.isAllStatus || that.isAllStatus != 1) && !that.formSurgeryStatus) {
                let setstatus = that.setUnLoginSurgeryStatus.split(`|`)
                newStatus = _.filter(allStatus, d => {
                    return d.value && setstatus.indexOf(d.value.toString()) > -1
                })
            } else if (that.formSurgeryStatus) {
                let setstatus = that.formSurgeryStatus.split(`|`)
                newStatus = _.filter(allStatus, d => {
                    return d.value && setstatus.indexOf(d.value.toString()) > -1
                })
            } else {
                newStatus = allStatus
            }
            newStatus = _.reduce(
                _.groupBy(newStatus, `label`),
                function(result, g, key) {
                    result.push({
                        label: key,
                        value: key
                    })
                    return result
                },
                []
            )
            that.allSurgeryStatus = newStatus
            console.log(`newStatus`)

            console.log(newStatus)
        },
        loadScheduleHeadingStyle(r) {
            let that = this
            that.nCostTime = 0
            that.allCostTime = 0
            _.forEach(r, t => {
                if (t.enum_surgery_status == 10 || t.enum_surgery_status == 20) { that.nCostTime = that.NumberAdd(that.nCostTime, parseFloat(t.cost_time || 0)) }
                that.allCostTime = that.NumberAdd(that.allCostTime, parseFloat(t.cost_time || 0))
            })

            that.jzCount = _.filter(r, { enum_surgery_type: 1 }).length
            that.zqCount = _.filter(r, { enum_surgery_type: 2 }).length
            var textInfo = `<div style="width: 100%;" class="align-center line-height100 surgeryStatus1">`
            _.forEach(that.unLoginScheduleHeadingStyleobj.surgeryStatus, d => {
                let rows = _.filter(r, c => {
                    return _.includes(d.surgeryStatus_array, c.enum_surgery_status.toString())
                })
                textInfo += `<i style="background: ${d.color}"></i>&nbsp;<span style="font-size: ${d.font_size}">${d.label}(${rows.length})</span>&nbsp;&nbsp;&nbsp;`
            })
            this.headText = textInfo.substring(0, textInfo.length - 18) + `</div>`
        },
        // 处理小数失精问题
        NumberAdd(arg1, arg2) {
            var r1, r2, m, n
            try {
                r1 = arg1.toString().split(`.`)[1].length
            } catch (e) {
                r1 = 0
            }
            try {
                r2 = arg2.toString().split(`.`)[1].length
            } catch (e) {
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2))
            n = (r1 >= r2) ? r1 : r2
            return ((arg1 * m + arg2 * m) / m).toFixed(n)
        },
        loadToken() {
            if (this.newuser) {
                this.user = decodeURIComponent(window.atob(this.newuser))
            }
            if (this.newkey) {
                this.key = decodeURIComponent(window.atob(this.newkey))
            }
            if (this.surgerycardno) {
                this.getSurgeryNameByCardNo(this.surgerycardno)
            }
            return new Promise(resolve => {
                let layoutlogin = 0
                if (this.user.split(`_`).length == 3 && this.user.split(`_`)[2] == `layoutlogin`) {
                    layoutlogin = 1
                }
                let username = this.user.split(`_`)[0]
                let password = this.user.split(`_`)[1]
                if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin && layoutlogin != 1) {
                    let encryptor = new JSEncrypt()
                    encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                    password = encryptor.encrypt(password)
                }
                let req = this.myaxios.post(`/api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: {
                        uid: username,
                        pwd: password,
                        exp: 100000,
                        layoutlogin: layoutlogin
                    }
                })

                req.then(data => {
                    this.isLogin = true
                    sessionStorage.setItem(`token`, data)
                    resolve(data)
                })
            })
        },
        loadDefaultValue() {
            let UnLoginScheduleDateDiff = this.$root.UnLoginScheduleDateDiff
            if (UnLoginScheduleDateDiff) {
                let rule = UnLoginScheduleDateDiff.split(`,`)

                return [
                    this.$moment().add(rule[0], `days`).format(`YYYY-MM-DD`),
                    this.$moment()
                        .add(rule[1], `days`)
                        .format(`YYYY-MM-DD`)
                ]
            } else {
                return [
                    this.$moment().add(0, `days`).format(`YYYY-MM-DD`),
                    this.$moment()
                        .add(0, `days`)
                        .format(`YYYY-MM-DD`)
                ]
            }
        },
        reload() {
            this.$nextTick(function() {
                this.$refs[`surgery-list`] && this.$refs[`surgery-list`].ReloadListData()
            })
        },
        loadingInpatientSectionData() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/InpatientSection/Search`)
                req.then(data => {
                    let sections = []
                    _.forEach(data, (g) => {
                        let r = g && {
                            jianpin: g.jianpin,
                            value: g.value,
                            label: g.label,
                            code: g.code
                        }
                        sections.push(r)
                    })

                    this.inpatient_section = sections
                    resolve(sections)
                })
            })
        },
        reloadListData() {
            let that = this
            // 更改日期触发更新列表
            return new Promise(resolve => {
                if (!that.isLogin) {
                    resolve([])
                    return
                }
                let req = that.myaxios.get(`/api/Preoperative/Apply/Get`, { begin: that.rdate[0], end: that.rdate[1], isAllStatus: that.isAllStatus, surgeryStatus: that.formSurgeryStatus, key: that.key })
                req.then(data => {
                    let r = data
                    if (that.dic_operating_ward_id) {
                        r = _.filter(r, { dic_operating_ward_id: parseInt(that.dic_operating_ward_id) })
                    }
                    // ACIS-23508 url添加科室code 在此进行过滤
                    // 2022-04-21 15:40, dongping.wang,ACIS-23508:提供给第三方的查看排程信息的url不支持传科室code 期望：提供给第三方的查看排程信息的url要支持传科室code
                    if (that.dic_section_id && that.dic_section_id.length > 0) {
                        r = _.filter(r, d => {
                            return _.includes(that.dic_section_id, d.dic_section_id)
                        })
                    }
                    if (that.dic_inpatient_id) {
                        r = _.filter(r, { dic_inpatient_section_id: that.dic_inpatient_id })
                    }
                    if (this.surgerycardno && this.surgeryname) {
                        r = _.filter(r, { surgeon: this.surgeryname })
                    }

                    if (that.unLoginScheduleHeadingStyleobj && that.unLoginScheduleHeadingStyleobj.surgeryStatus) {
                        r = _.map(r, d => {
                            _.forEach(that.unLoginScheduleHeadingStyleobj.surgeryStatus, t => {
                                if (_.includes(t.surgeryStatus_array, d.enum_surgery_status.toString())) {
                                    d.surgery_status1 = t.label
                                    d.row_style = { 'background-color': `${t.color} !important`, 'color': `black !important` } // ${d.enum_surgery_type == 1 ? `red` : `black`}
                                    return false
                                } else {
                                    d.surgery_status1 = d.surgery_status
                                    d.row_style = { 'color': `black !important` }
                                }
                            })
                            d.abbr = d.abbrs.join(`;`)
                            // reload的时候把动态列字段放到obj对象里面
                            if (that.extendColumnList) {
                                that.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(that.extendColumnList, d, d)
                            }
                            return d
                        })
                    } else {
                        r = _.map(r, d => {
                            d.class_name = `surgery_status_${d.enum_surgery_status} surgery_type_${d.enum_surgery_type}`
                            d.surgery_status1 = d.surgery_status
                            d.abbr = d.abbrs.join(`;`)
                            // reload的时候把动态列字段放到obj对象里面
                            if (that.extendColumnList) {
                                that.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(that.extendColumnList, d, d)
                            }
                            return d
                        })
                    }
                    if (that.surgery_status && that.surgery_status.length > 0) {
                        r = _.filter(r, d => {
                            return _.includes(that.surgery_status, d.surgery_status1)
                        })
                    }
                    if (that.surgery_type && that.surgery_type > 0) {
                        r = _.filter(r, d => {
                            return d.enum_surgery_type == that.surgery_type
                        })
                    } else if (that.surgery_type == -1) {
                        r = _.filter(r, d => {
                            return d.enum_surgery_type == 1 && d.is_emergency == 1
                        })
                    }
                    if (that.unLoginScheduleHeadingStyleobj) {
                        this.loadScheduleHeadingStyle(r)
                    }
                    // r = r.sort((a, b) => a.display_order - b.display_order)
                    this.surgeryList = r
                    resolve(r)
                }).catch(e => {
                    resolve([])
                })
            })
        },
        getStatusStyleConfig() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=SurgeryStatusStyleConfig`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.statusStyleConfig = JSON.parse(data.value)
                    } else {
                        this.statusStyleConfig = []
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadWorkStation() {
            let that = this
            return new Promise((resolve, reject) => {
                if (!this.isLogin) {
                    resolve([])
                    return
                }

                let req = this.myaxios.get(`/api/AcisSystem/WorkstationConfig/Get?token=${that[`localip/ipAddress`]}`)
                req.then(data => {
                    if (data) {
                        let req1 = this.myaxios.get(`/api/AcisSystem/OperatingRoom/Get/${data.dic_operating_room_id || 0}`)
                        req1.then(d => {
                            this.dic_operating_ward_id = (d && d.dic_operating_ward_id) || data.dic_recovery_ward_id
                        }).catch(e => {
                            console.log(e)
                        })
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        getstyle(row) {
            let styleConfig = {}
            if (this.statusStyleConfig.length > 0) {
                var config = _.filter(this.statusStyleConfig, function(i) {
                    return i.value == row.enum_surgery_status
                })
                if (config.length > 0) {
                    return config[0] && config[0].style
                }
            }
            return styleConfig
        },
        ExportExcel() {
            let from = this.$moment(this.rdate[0]).format(`YYYY-MM-DD`)
            let to = this.$moment(this.rdate[1]).add(1, `days`).format(`YYYY-MM-DD`)
            let wardId = this.dic_operating_ward_id || 0
            let sectionId = this.dic_section_id && this.dic_section_id.join(`,`) || 0
            this.myaxios.get(`/api/Preoperative/Schedule/GetScheduleForExportMultiSection`, { wardId: wardId, from: from, to: to, sectionIds: sectionId }).then(data => {
                if (data.length <= 0) {
                    this.$message.warning(`暂无导出数据`)
                    return
                }
                // 是否需要按状态过滤
                let filterdata = this.isEnableFilterStatusForExportExcel && this.isEnableFilterStatusForExportExcel == `1`
                if (filterdata) {
                    this.exportExcel.exportDatas = data
                    this.exportExcel.dialogFormVisible = true
                } else {
                    this.myaxios.export_excel(data, `手术排程.xls`)
                }
            })
        },
        exportExcelSave(row) {
            let data = this.exportExcel.exportDatas
            if (row.status.length > 0 && data.length > 0) {
                let filterExportData = !_.has(data[0], `状态`) ? data : _.filter(data, c => {
                    return _.includes(row.status, c[`状态`])
                })

                if (filterExportData.length <= 0) {
                    this.$message.warning(`暂无导出数据`)
                    return
                }
                this.myaxios.export_excel(filterExportData, `手术排程.xls`).then(data => {
                    this.exportExcel.dialogFormVisible = false
                    this.exportExcel.exportDatas = []
                })
            }
        },
        loadButtonsShowHidden() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(permissions => {
                this.isShowPrint = _.find(permissions, { no: `unLoginApplySurgery_Print` }) != undefined
                this.isShowExport = _.find(permissions, { no: `unLoginApplySurgery_Export` }) != undefined
                this.isCreateEmergency = _.find(permissions, { no: `unLoginApplySurgery_CreateEmergency` }) != undefined
                this.isSearchEmergency = _.find(permissions, { no: `unLoginApplySurgery_SearchEmergency` }) != undefined
            }).catch(e => {
                console.log(e)
            })
        },
        // 加载配置列
        loadConfigColumns() {
            let req = this.myaxios.get(`api/AcisSystem/SystemServer/GetColumnConfig?tableName=api_Preoperative/unLoginApply`)
            req.then(data => {
                let lcs = _.orderBy(this.columnList, function(lc) {
                    return _.findIndex(data, { col_name: lc.prop })
                })
                this.configColumns = lcs
                    .map(c => {
                        return { value: c.prop, label: c.label, isListable: c.isListable }
                    })
                    .filter(d => {
                        return d.label != `unique` && d.isListable
                    })
                this.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
            })
        },
        // 保存配置列
        SaveUserColumns() {
            let uc = this.configColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    table_name: `api_Preoperative/unLoginApply`
                }
            })
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                if (this.reload) {
                    this.reload()
                }
            }).catch(e => {})
        },
        configColumnDrop() {
            // if (!this.columnConfig) return
            const tbody = document.querySelector(`.config-column .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        },
        accurateQuery(drawer) {
            if (this.unLoginScheduleHeadingStyle) {
                this.queryPanelHeight = 38
                if (drawer) {
                    this.queryPanelHeight = 90 + this.formHeight
                } else {
                    this.queryPanelHeight = -8 + this.formHeight
                }
            } else {
                if (drawer) {
                    this.queryPanelHeight = 60
                } else {
                    this.queryPanelHeight = -30
                }
            }
        },
        // 根据工号获取手术医生
        getSurgeryNameByCardNo(surgerycardno) {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetByUserCode?UserCode=${surgerycardno}`)
            req.then(data => {
                this.surgeryname = data && data.name
            })
        },
        // 根据手术医生和麻醉医生简拼查询
        search() {
            let surgeonk = (this.surgeon && this.surgeon.toUpperCase()) || ``
            let anesk = (this.anes_doctor && this.anes_doctor.toUpperCase()) || ``
            let r = _.filter(this.surgeryList, d => {
                let result = true
                if (result && surgeonk.length > 0) {
                    result =
                        (d.plan_surgeon_doctor && (d.plan_surgeon_doctor.label.toUpperCase().indexOf(surgeonk) > -1 || d.plan_surgeon_doctor.jianpin.toUpperCase().indexOf(surgeonk) > -1))
                }
                if (result && anesk.length > 0) {
                    result =
                        (d.plan_anes_doctor && (d.plan_anes_doctor.label.toUpperCase().indexOf(anesk) > -1 || d.plan_anes_doctor.jianpin.toUpperCase().indexOf(anesk) > -1))
                }
                return result
            })
            this.$refs[`surgery-list`].dataList = r
        }
    },
    watch: {
        surgeon: function(newVlaue, oldValue) {
            this.search()
        },
        anes_doctor: function(newVlaue, oldValue) {
            this.search()
        }
    }

}
</script>
<style lang="less">
.title1 p {
    background: lightgray;
    font-size: 20px;
}
.title2 p {
    background: lightgray;
    font-size: 20px;
}
.surgery_status_20 td {
    color: var(--primary-color, #009688);
}
.surgery_type_1 td {
    color: #f56c6c;
}
.surgeryType {
    width: 120px;
    display: inline-block;
    height: 30px;
    // font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #333333;
    opacity: 1;
    i {
        width: 16px;
        height: 16px;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }
}
.surgeryStatus1 {
    width: 150px;
    display: inline-block;
    height: 30px;
    // font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: black;
    opacity: 1;
    i {
        width: 25px;
        height: 16px;
        border: #656565 solid 1px;
        display: inline-block;
        vertical-align: middle;
    }
}
#unlogin .el-table__body tr .cell {
    height: 30px; //设置高度 主要是这个
    line-height: 35px;
    div {
        height: 30px;
        line-height: 35px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/UnLoginApplySurgery.vue